/**
  * 献礼文章 接口的统一出口
  */
import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const xliarticle = {
    // 列表
    list(params) {
        return axios.get(api + 'xliarticle/list', { params: params })
    },
    //详情
    detail(params) {
        return axios.get(api + 'xliarticle/detail', { params: params })
    },
    //修改
    edit(params) {
        return axios.post(api + 'xliarticle/edit', qs.stringify(params))
    },
    //审核
    review(params) {
        return axios.post(api + 'xliarticle/review', qs.stringify(params))
    },
    //助力列表
    helplist(params) {
        return axios.get(api + 'xliarticle/helplist', { params: params })
    },
    //评论列表
    commentlist(params) {
        return axios.get(api + 'xliarticle/commentlist', { params: params })
    },
    //删除评论
    removecomment(params) {
        return axios.post(api + 'xliarticle/removecomment', qs.stringify(params))
    },
}


// 导出接口
export default xliarticle